<template>
  <section class="resources">
    <TopBanner class="mb-16" :item="banner" />
    <div class="container _py-12 _py-md-12 _px-md-4">
      <AppBtnBreadCrumb class="_mb-4" />
    </div>
    <div class="drop__items">
      <div class="container _pb-12 _px-md-4">
        <DropItem v-for="(item, i) in resourcesItems" :key="i" :item="item" />
      </div>
    </div>
  </section>
</template>

<script>
import TopBanner from '@/components/UI/banners/TopBanner'
import toPage from '@/mixins/toPage'
import AppBtnBreadCrumb from '@/components/UI/buttons/AppBtnBreadCrumb'
import DropItem from '../components/UI/DropItem.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  metaInfo() {
    return {
      title: this.$t('pages.resources.title').replace(/<[^>]*>?/gm, ' '),
    }
  },
  name: 'UsefulResources',
  mixins: [toPage],
  components: {
    DropItem,
    TopBanner,
    AppBtnBreadCrumb,
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['SOCKET_MESSAGES']),
    currentLocale() {
      return this.Trans.currentLocale
    },
    banner() {
      return {
        title: this.$t('pages.resources.title'),
        theme: 'light',
        images: [
          {
            src: require(`@/assets/img/banners/resources/${this.currentLocale}/resources-375.jpg`),
            media: '(max-width: 743px)',
          },
          {
            src: require(`@/assets/img/banners/resources/${this.currentLocale}/resources-768.jpg`),
            media: '(max-width: 1220px)',
          },
          {
            src: require(`@/assets/img/banners/resources/${this.currentLocale}/resources-1440.jpg`),
            media: '(max-width: 1919px)',
          },
          {
            src: require(`@/assets/img/banners/resources/${this.currentLocale}/resources-1920.jpg`),
            media: '(min-width: 1920px)',
          },
        ],
      }
    },
    //resourcesItems() {
      //return this.$t('pages.resources.items')
    //},
    // скрыл блок соцсетей и ЗАКАЗЫ HN
    resourcesItems() {
      const items = this.$t('pages.resources.items');
      
      // 1. Удаляем блок соцсетей (третий элемент)
      let filteredItems = items.length >= 3 
        ? [...items.slice(0, 2), ...items.slice(3)] 
        : items;
      
      // 2. Фильтрация и модификация элементов
      return filteredItems.map(item => {
        if (item.childrens) {
          // Обрабатываем first_col
          if (item.childrens.first_col) {
            item.childrens.first_col = item.childrens.first_col
              .filter(child => child.title !== "ЗАКАЗЫ HN") // Удаляем элемент
              .map(child => {
                // Модифицируем Telegram-канал
                if (child.title === "НОВОСТНОЙ КАНАЛ В TELEGRAM") {
                  return {
                    ...child,
                    title: "БИБЛИОТЕКА МАТЕРИАЛОВ В TELEGRAM",
                    description: "Обучающие материалы для бизнеса, информация по продуктам и другие полезные ресурсы собраны в одном месте"
                  };
                }
                return child;
              });
          }
          
          // Обрабатываем second_col (на всякий случай)
          if (item.childrens.second_col) {
            item.childrens.second_col = item.childrens.second_col
              .filter(child => child.title !== "ЗАКАЗЫ HN");
          }
        }
        return item;
      });
    },
    items() {
      return this.$t('pages.resources.items').map(function (el) {
        return {
          ...el,
        }
      })
    },
  },
  methods: {
    ...mapActions(['fetchStaticView', 'SOCKET_SEND_MESSAGE']),
  },
  mounted() {
    this.fetchStaticView('usefull')
    if (this.SOCKET_MESSAGES === null) {
      this.SOCKET_SEND_MESSAGE(
        JSON.stringify({
          action: 'set_path',
          path: this.$router.resolve({
            name: this.$route.name.replace('Loc', ''),
          }).href,
        })
      )
    }
  },
  watch: {
    SOCKET_MESSAGES() {
      if (this.SOCKET_MESSAGES === null) {
        this.SOCKET_SEND_MESSAGE(
          JSON.stringify({
            action: 'set_path',
            path: this.$router.resolve({
              name: this.$route.name.replace('Loc', ''),
            }).href,
          })
        )
      }
    },
  },
}
</script>

<style lang="scss"></style>
